module.exports = __webpack_public_path__ + "img/financial-information.svg";